document.addEventListener("DOMContentLoaded", function() {
  const readMoreBtn = document.getElementById("read-more");
  const collectionDesc = document.getElementById("collection-description");

  if (collectionDesc && readMoreBtn) {
    readMoreBtn.addEventListener("click", function() {
      collectionDesc.classList.toggle("expanded");

      if (collectionDesc.classList.contains("expanded")) {
        readMoreBtn.textContent = "Read Less";
      } else {
        readMoreBtn.textContent = "Read More";
      }
    });
  }
});
